import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UPDATE_NAV_ITEM } from '../../../../../store/js/modules/statspro/career-and-season-stats/actions';
import { careerAndSeasonStatsNavSelector } from '../../../../../store/js/modules/statspro/career-and-season-stats/selectors';

export const useCareerAndSeasonStatsNavSync = ( { competitions, seasons } ) => {
    const dispatch = useDispatch();
    const nav = useSelector( careerAndSeasonStatsNavSelector );

    /**
     * Set initial nav values
     */
    useEffect( () => {
        if ( competitions && !nav.competition.id ) {
            const { PREMIERSHIP } = PULSE.app.common.CONSTANTS.PROVIDER_IDS;
            const aflPremiershipCompetition = competitions.find(
                comp => comp.providerId === PREMIERSHIP
            );

            if ( aflPremiershipCompetition ) {
                dispatch(
                    UPDATE_NAV_ITEM.request( {
                        navItem: 'competition',
                        value: { id: aflPremiershipCompetition.id }
                    } )
                );
            }
        }

        if ( seasons && !nav.season.id ) {
            dispatch(
                UPDATE_NAV_ITEM.request( {
                    navItem: 'season',
                    value: { id: seasons[ 0 ].id }
                } )
            );
        }
    }, [ competitions, seasons ] );
};